{"version":"2026.08.04-HOTFIX-1","git":{"branch":null,"hash":null,"fullHash":null},"timestamp":1788110347573}